<app-thumbnail-item
  [item]="item"
  [routerLink]="getRouterLink(item)"
  [queryParams]="item.$$refData?.queryParams"
  [tooltipText]="isCheckboxDisabled(item) && !item.$$used ? ('TRANS__SEARCH_SELECTIONS__TOO_MANY_SELECTED' | translate) : ''"
  [isSelected]="searchContainer.selections.selected[item.artifact_id]"
  [isDisabled]="isCheckboxDisabled(item) && !item.$$used"
  (select)="select($event.item, $event.event)"
  tabindex="-1"
>
  @if (item['package_placement.package_id'] && objectPageV2) {
    <app-search-result-package-indicator indicator [item]="item"/>
  }
</app-thumbnail-item>
